export default "__VITE_ASSET__Bj8_TvVZ__"